import { render, staticRenderFns } from "./BrokerProportion.vue?vue&type=template&id=103a642b&scoped=true"
import script from "./BrokerProportion.vue?vue&type=script&lang=js"
export * from "./BrokerProportion.vue?vue&type=script&lang=js"
import style0 from "./BrokerProportion.vue?vue&type=style&index=0&id=103a642b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103a642b",
  null
  
)

export default component.exports